import React from 'react'
import { Grid, Row, Col} from 'react-bootstrap'


class Contact extends React.Component{
  render(){
    return(<div><p></p></div>);
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Contact/Contact.jsx